import { DEFAULT_TRANSITION_ALL } from "utils/styles";
import React from "react";
import styled from "styled-components";

const Wrapper = styled.div`
  margin-bottom: 0.875em;
  width: 100%;
`;

const Label = styled.label`
  align-items: center;
  cursor: pointer;
  display: flex;
  overflow: hidden;
  position: relative;
`;

const Icon = styled.i`
  display: block;
  margin-right: 6px;
  width: 24px;
`;

const Title = styled.span`
  display: block;
  flex-grow: 1;
  margin-left: ${({ hasIcon }) => (hasIcon ? "" : "2rem")};
`;

const Status = styled.span`
  ${DEFAULT_TRANSITION_ALL};
  border-radius: 15px;
  background: ${({ isActive }) => (isActive ? "#fff" : "#000")};
  color: ${({ isActive }) => (isActive ? "#000" : "#fff")};
  font-size: 10px;
  padding: 2px 8px;
`;

const Checkbox = styled.input`
  left: -100px;
  position: absolute;
  top: 0;
`;

export default function FilterItem(props) {
  const handleChange = (e) => {
    props.onChange(props.path, e.target.checked);
  };
  return (
    <Wrapper>
      <Label>
        {props.icon ? (
          <Icon
            className={`material-icons-round md-18 ${props.iconClass || ""}`}
          >
            {props.icon}
          </Icon>
        ) : null}
        <Title hasIcon={Boolean(props.icon)}>{props.title}</Title>
        <Status isActive={props.isActive}>
          {props.isActive ? "On" : "Off"}
        </Status>
        <Checkbox
          onChange={handleChange}
          checked={props.isActive}
          type="checkbox"
        />
      </Label>
    </Wrapper>
  );
}
